export default function MintInformation() {
  const characters = [
    {
      name: "Ignis & Pyra",
      image: "/rumble 3/9814.png",
      bgColor: "bg-red-500",
      element: "fire",
      stats: {
        power: 90,
        speed: 75,
        defense: 65
      }
    },
    {
      name: "Aqua & Marina",
      image: "/rumble 3/9882.png",
      bgColor: "bg-blue-500",
      element: "water",
      stats: {
        power: 70,
        speed: 85,
        defense: 80
      }
    },
    {
      name: "Terra & Gaia",
      image: "/rumble 3/9659.png",
      bgColor: "bg-emerald-600",
      element: "earth",
      stats: {
        power: 85,
        speed: 60,
        defense: 95
      }
    },
    {
      name: "Zephyr & Aero",
      image: "/rumble 3/9563.png",
      bgColor: "bg-cyan-500",
      element: "air",
      stats: {
        power: 75,
        speed: 95,
        defense: 60
      }
    }
  ];

  const getStatColor = (value: number) => {
    if (value >= 80) return 'text-green-400';
    if (value >= 60) return 'text-yellow-400';
    return 'text-red-400';
  };

  return (
    <div className="min-h-screen text-white relative overflow-hidden bg-[#0A0A0F]">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(99,102,241,0.15),rgba(0,0,0,0)_70%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_60%,rgba(245,158,11,0.1),rgba(0,0,0,0)_50%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,transparent,rgba(0,0,0,0.4))]" />
      <div className="absolute inset-0 bg-grid-white/[0.02]" />

      <div className="relative container mx-auto px-4 py-24 z-10">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Left Side - Mint Info */}
          <div className="flex-1 space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary-400 to-primary-400 code-mono">
                Mint Information
              </h2>
              <p className="text-gray-400 text-lg code-mono">
                Join the elemental revolution. Mint your warrior and begin your journey in the arena.
              </p>
            </div>

            {/* Mint Details */}
            <div className="space-y-6 bg-black/40 backdrop-blur-sm rounded-xl p-8 border border-white/5">
              <div className="space-y-2">
                <h3 className="text-xl font-bold text-primary-400 code-mono">Supply</h3>
                <p className="text-gray-300 code-mono">4096 Elemental Warriors</p>
              </div>

              <div className="space-y-2">
                <h3 className="text-xl font-bold text-primary-400 code-mono">Mint Date</h3>
                <p className="text-gray-300 code-mono">TBD</p>
              </div>

              <div className="space-y-2">
                <h3 className="text-xl font-bold text-primary-400 code-mono">Mint Price</h3>
                <p className="text-gray-300 code-mono">0.5 SOL</p>
              </div>
            </div>

            {/* Price Tiers */}
            <div className="flex flex-wrap gap-4">
              <div className="group relative">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                <button className="relative px-8 py-3 bg-black rounded-lg code-mono flex items-center gap-2 group-hover:text-amber-500 transition-colors">
                  OG: coming soon
                  <span className="text-lg">🔒</span>
                </button>
              </div>

              <div className="group relative">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                <button className="relative px-8 py-3 bg-black rounded-lg code-mono flex items-center gap-2 group-hover:text-primary-500 transition-colors">
                  WL: coming soon
                  <span className="text-lg">🔒</span>
                </button>
              </div>

              <div className="group relative">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-gray-400 to-gray-500 rounded-lg blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                <button className="relative px-8 py-3 bg-black rounded-lg code-mono flex items-center gap-2 group-hover:text-gray-400 transition-colors">
                  Public: coming soon
                  <span className="text-lg">🔒</span>
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Character Cards */}
          <div className="flex-1 grid grid-cols-2 gap-6">
            {characters.map((char) => (
              <div key={char.name} className="gaming-container relative group">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                <div className="relative bg-black/60 backdrop-blur-sm p-4 pb-16 rounded-lg border border-white/5">
                  {/* Faction Name at Top */}
                  <div className={`${char.bgColor} py-2 px-4 rounded-t absolute top-0 left-0 right-0 text-center`}>
                    <h3 className="text-lg font-bold text-white code-mono uppercase">
                      {char.element === 'fire' ? 'The Flames of Rebirth' : 
                       char.element === 'air' ? 'The Whispering Winds' :
                       char.element === 'water' ? 'The Eternal Tides' :
                       char.element === 'earth' ? 'The Guardians of the Land' :
                       `${char.element} Faction`}
                    </h3>
                  </div>

                  {/* Character Image with padding for top faction name */}
                  <div className="mt-10">
                    <img
                      src={char.image}
                      alt={char.name}
                      className="w-full h-48 object-cover rounded mb-4"
                    />
                  </div>

                  {/* Stats Section */}
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-sm code-mono">POWER</span>
                      <div className="flex items-center gap-2">
                        <div className="w-32 h-2 bg-gray-700 rounded-full overflow-hidden">
                          <div 
                            className={`h-full ${char.bgColor}`}
                            style={{ width: `${char.stats.power}%` }}
                          />
                        </div>
                        <span className={`text-sm code-mono ${getStatColor(char.stats.power)}`}>
                          {char.stats.power}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm code-mono">SPEED</span>
                      <div className="flex items-center gap-2">
                        <div className="w-32 h-2 bg-gray-700 rounded-full overflow-hidden">
                          <div 
                            className={`h-full ${char.bgColor}`}
                            style={{ width: `${char.stats.speed}%` }}
                          />
                        </div>
                        <span className={`text-sm code-mono ${getStatColor(char.stats.speed)}`}>
                          {char.stats.speed}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm code-mono">DEFENSE</span>
                      <div className="flex items-center gap-2">
                        <div className="w-32 h-2 bg-gray-700 rounded-full overflow-hidden">
                          <div 
                            className={`h-full ${char.bgColor}`}
                            style={{ width: `${char.stats.defense}%` }}
                          />
                        </div>
                        <span className={`text-sm code-mono ${getStatColor(char.stats.defense)}`}>
                          {char.stats.defense}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Hero Name at Bottom */}
                  <div className={`${char.bgColor} py-2 px-4 rounded-b absolute bottom-0 left-0 right-0 text-center`}>
                    <h3 className="text-xl font-bold text-white code-mono">
                      {char.name}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
